import { CategoryInterface } from './category.interface';

export class Category {
  /**
   * the category id
   */
  id: number;

  /**
   * the category name
   */
  nom: string;

  /**
   * the category plans number
   */
  nbPlans: number;

  /**
   * Creates an instance of Category.
   *
   * @param jsonData Category
   */
  constructor(jsonData: CategoryInterface) {
    this.nom = jsonData.nom;
    this.id = jsonData.id;
    this.nbPlans = jsonData.nbPlans;
  }
}
